import { css } from "@emotion/css";
import { resetStyles } from "@octopusdeploy/design-system-components";
import type { ReactNode } from "react";
export function ProcessSidebarStepMessages({ messages }: {
    messages: ReactNode[];
}) {
    return (<ul className={styles.list}>
            {messages.map((message, i) => (<li key={i}>{message}</li>))}
        </ul>);
}
const styles = {
    list: css({
        ...resetStyles.list,
    }),
};
